import React from 'react';
import './DataTypeSelector.css';

function DataTypeSelector({ dataTypes, selectedType, onSelectType, disabled }) {
  return (
    <div className="data-type-selector">
      <label htmlFor="dataType">Data Type</label>
      <select
        id="dataType"
        value={selectedType}
        onChange={(e) => onSelectType(e.target.value)}
        disabled={disabled}
      >
        {dataTypes.map((type) => (
          <option key={type.id} value={type.id}>
            {type.name}
          </option>
        ))}
      </select>
      {selectedType && (
        <p className="type-description">
          {dataTypes.find(t => t.id === selectedType)?.description}
        </p>
      )}
    </div>
  );
}

export default DataTypeSelector;
